export class NoUserError extends Error {
  constructor(public message = 'No authenticated user found') {
    super(message);
    this.name = 'NoUserError';
  }
}
